import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductSummaryList as ProductSummaryListComponent } from '../../../../vtex-apps/product-summary/ProductSummaryList/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function RelatedProducts() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'RelatedProducts',
		props: VisibilityLayout({ mzTitle: 'MZ | Produtos Relacionados (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'related-products-wrapper__flex-row-2',
					fullWidth: false,
					mzTitle: 'MZ | Vitrine Produtos Relacionados',
				},
				[
					FlexLayoutCol(
						{
							blockClass: 'related-products__flex-col-2',
						},
						[
							RichText({
								textAlignment: 'CENTER',
								textPosition: 'CENTER',
								text: 'Quem comprou, comprou também',
								blockClass: 'related-products__title-2',
							}),
							ProductSummaryListComponent(
								{
									blockClass: 'related-products-summary__list-2',
								},
								[
									SliderLayout({
										blockClass: 'related-products-summary__slider-layout-2',
										itemsPerPage: {
											desktop: 4,
											tablet: 2,
										},
									}),
								],
								[
									{
										componentGroup: 'ProductSummaryShelf',
										componentName: 'ProductSummaryShelfComponent',
										componentId: uuidv4(),
									},
								],
							),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--transparent', to: '--rp-bg-color', name: 'Background' },
			{ from: '--brand-color-primary-pure', to: '--rp-slider-color', name: 'Slider' },
			{ from: '--white', to: '--rp-slider-arrow-color', name: 'Arrow' },
			{ from: '--white', to: '--rp-slider-dots-color', name: 'Dots' },
			{ from: '--text-color-1', to: '--rp-heading-color', name: 'Heading' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--rp-border-radius', name: 'Slider' }],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-xxl', to: '--rp-heading-fs', name: 'Heading' }],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--rp-heading-fw', name: 'Heading' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--rp-heading-ff', name: 'Heading' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--rp-dot-width', name: 'Dot Width' },
			{ from: '--spacing-nano', to: '--rp-dot-height', name: 'Dot Height' },
			{ from: '--spacing-xxxs', to: '--rp-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--rp-dot-height-active', name: 'Dot Height Active' },
			// { from: "--spacing-md", to: "--rp-slider-buttons", name: "Slider Buttons" },
		],
	},
];
